import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Box, Divider } from "@mui/material";
import DocumentViewer from "./DocumentViewer";
import AISuggestionsPanel from "./AISuggestionsPanel";
import useDocument from "./useDocument";
// Set workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DocumentExtraction = () => {
    const { projectId, packageId, subcontractorId, documentId } = useParams();
    const [leftWidth, setLeftWidth] = useState(50); // Default to half the screen
    const MIN_WIDTH_PERCENT = 10;

    const { fileType, file, excelData, loading, error } = useDocument(
        projectId,
        packageId,
        subcontractorId,
        documentId,
    );

    const handleDrag = (event) => {
        event.preventDefault();
        const newLeftWidth = Math.max(
            MIN_WIDTH_PERCENT,
            Math.min(
                100 - MIN_WIDTH_PERCENT,
                (event.clientX / window.innerWidth) * 100,
            ),
        );
        setLeftWidth(newLeftWidth);
    };

    const dividerStyle = {
        cursor: "col-resize",
        "&:hover": { bgcolor: "primary.main" },
        width: "10px",
        mx: "-2px",
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                height: "100vh",
                width: "100%",
            }}
        >
            <Box sx={{ width: `${leftWidth}%`, overflowY: "auto" }}>
                <DocumentViewer
                    file={file}
                    fileType={fileType}
                    excelData={excelData}
                />
            </Box>
            <Divider
                orientation="vertical"
                sx={dividerStyle}
                onMouseDown={(event) => {
                    window.onmousemove = handleDrag;
                    window.onmouseup = () =>
                        (window.onmousemove = window.onmouseup = null);
                }}
            />
            <Box sx={{ width: `${100 - leftWidth}%`, overflowY: "auto" }}>
                <AISuggestionsPanel
                    projectId={projectId}
                    packageId={packageId}
                    subcontractorId={subcontractorId}
                    documentId={documentId}
                />
            </Box>
        </Box>
    );
};

export default DocumentExtraction;
